import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { deleteMedia, fetchMedia, getMediaList } from '../../store/coctailsSlice';
import styles from './AudioPage.module.scss';
import { useEffect, useState } from 'react';
import useMedia from '../../lib/hooks/useMedia';
import { Modal, Popconfirm, message } from 'antd';
import { Layout } from '../../components';
import { CloseCircleOutlined } from '@ant-design/icons';
import { API_URL } from '../../lib/api/index';

const AudioPage = ({ logOut }: { logOut: () => void }) => {
  const media = getMediaList(useAppSelector(state => state.coctailsReducer));
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const { onUseMedia } = useMedia();
  const [open, setOpen] = useState(false);
  const [nameImage, setNameImage] = useState<string>('');

  const showModal = () => {
    setOpen(true);
  };

  const getAllMedia = async () => {
    setLoading(true);
    await dispatch(fetchMedia('audio'));
    setLoading(false);
  };

  useEffect(() => {
    getAllMedia();
  }, []);

  const onDeleteAudio = async (name?: string) => {
    onCancel();
    await dispatch(
      deleteMedia({
        name: name || nameImage,
        type: 'audio',
      }),
    );
    getAllMedia();
    message.success('Audio deleted successfully!');
  };

  const onConfirm = (name: string) => {
    setNameImage(name);
    const isUsedAudio = onUseMedia('AUDIO', name);
    isUsedAudio ? showModal() : onDeleteAudio(name);
  };

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <Layout
      logOut={logOut}
      loading={loading}
      title={<div className={styles.layoutTitle}>Audio</div>}
    >
      <div>
        {!loading && (
          <div className={styles.wrap}>
            {media?.map((i: { name: string }) => (
              <div className={styles.itemWrap} key={i.name}>
                <audio controls src={`${API_URL}/storage/audio/${i.name}`}></audio>
                <Popconfirm
                  title="Are you sure you want to delete?"
                  onConfirm={() => onConfirm(i?.name)}
                  okText="Yes"
                  cancelText="No"
                >
                  <CloseCircleOutlined className={styles.itemDelete} />
                </Popconfirm>
              </div>
            ))}
          </div>
        )}
        <Modal open={open} title="Title" onOk={() => onDeleteAudio()} onCancel={onCancel}>
          <p>This image is used. Are you sure you want to delete it?</p>
        </Modal>
      </div>
    </Layout>
  );
};

export default AudioPage;
